import { Component } from '@angular/core';

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.scss', '../management.shared.scss'],
    standalone: false
})
export class GroupsComponent {

}
